/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindContactrMappingQueryResponse,
  FindContactrMappingQueryParams,
} from "../types/FindContactrMapping.ts"

export const findContactrMappingQueryKey = (
  params: FindContactrMappingQueryParams
) =>
  [
    { url: "/v1/client-settings/find-supplier-mapping" },
    ...(params ? [params] : []),
  ] as const

export type FindContactrMappingQueryKey = ReturnType<
  typeof findContactrMappingQueryKey
>

/**
 * @summary Find contact
 * {@link /v1/client-settings/find-supplier-mapping}
 */
export async function findContactrMapping(
  params: FindContactrMappingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindContactrMappingQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-supplier-mapping`,
    params,
    ...requestConfig,
  })
  return res
}

export function findContactrMappingQueryOptions(
  params: FindContactrMappingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findContactrMappingQueryKey(params)
  return queryOptions<
    ResponseConfig<FindContactrMappingQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindContactrMappingQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findContactrMapping(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find contact
 * {@link /v1/client-settings/find-supplier-mapping}
 */
export function useFindContactrMapping<
  TData = ResponseConfig<FindContactrMappingQueryResponse>,
  TQueryData = ResponseConfig<FindContactrMappingQueryResponse>,
  TQueryKey extends QueryKey = FindContactrMappingQueryKey,
>(
  params: FindContactrMappingQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindContactrMappingQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findContactrMappingQueryKey(params)

  const query = useQuery(
    {
      ...findContactrMappingQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
